(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@price-point/application-base", [], factory);
	else if(typeof exports === 'object')
		exports["@price-point/application-base"] = factory();
	else
		root["@price-point/application-base"] = factory();
})(this, function() {
return 